import { Controller } from '@hotwired/stimulus';

export default class GetFormController extends Controller {
  submit() {
    const url      = new URL(this.element.action);
    const formData = new FormData(this.element);
    url.search     = new URLSearchParams(formData).toString();

    location.href = url.href;
  }
}
